import { render, staticRenderFns } from "./kv-file-dropzone.vue?vue&type=template&id=0a9ed465"
import script from "./kv-file-dropzone.vue?vue&type=script&lang=js"
export * from "./kv-file-dropzone.vue?vue&type=script&lang=js"
import style0 from "./kv-file-dropzone.vue?vue&type=style&index=0&id=0a9ed465&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports